<template>
    <table-ish>
        <table-ish-row
            v-for="tenant in tenants"
            :key="tenant.uuid"
        >
            <table-ish-cell>
                <tenants-current
                    v-slot="{
                        data
                    }"
                >
                    <template v-if="data && data.object === tenant.object && data.uuid === tenant.uuid">
                        You
                    </template>
                    <template v-else>
                        {{ tenant.name }}
                    </template>
                </tenants-current>
            </table-ish-cell>

            <table-ish-cell
                v-if="false"
                :shrink="true"
            >
                <base-dropdown placement="bottom-end">
                    <button
                        slot="trigger"
                        slot-scope="{ is_open, toggle }"
                        :class="{ 'shadow-outline': is_open }"
                        class="btn btn-none"
                        type="button"
                        @click.prevent="toggle"
                    >
                        <base-svg
                            name="icon-dots-horizontal"
                            class="w-6 h-6"
                        />
                    </button>
                    <div
                        slot="menu"
                        class="py-2 text-white rounded shadow-lg bg-grey-darker mt-3px"
                    >
                        <router-link
                            :to="{
                                path: '#'
                            }"
                            class="block p-3 font-semibold leading-none no-underline text-inherit hover:bg-grey-darker-10pcl"
                        >
                            Invite to another tenancy
                        </router-link>
                    </div>
                </base-dropdown>
            </table-ish-cell>
        </table-ish-row>
    </table-ish>
</template>

<script>
    import TenantsCurrent from './tenants-current'

    export default {
        components: {
            TenantsCurrent
        },
        props: {
            tenants: {
                type: Array,
                required: true
            }
        }
    }
</script>
